let grecaptcha = window.grecaptcha || {};

window.giftcardOnloadCallback = () => {
  const giftCardRecaptcha = document.getElementById('GiftCardPage__recaptcha');
  if (giftCardRecaptcha) {
    grecaptcha?.render('GiftCardPage__recaptcha', {
      sitekey: '6Lc-fN8ZAAAAAGRSMGzWYKzRgg63c_c5LXGrmKCk',
    });
  }
};

const getErrorMessageFromError = (errorText) => {
  switch (errorText) {
    case 'givex_number is required.':
      return 'Card Number is required';

    case 'Givex error 41: Invalid security code':
      return 'Invalid PIN';

    case 'Givex error 2: Cert not exist':
      return 'Card Number does not exist';

    case 'security_code is required.':
      return 'Card PIN is required';

    default:
      return errorText;
  }
};

const fetchGiftCardBalance = async (card_number, card_pin) => {
  const domain = window.location.host;
  const url =
    domain === 'www.windsorstore.com'
      ? 'https://gift-card-service.wndsr.io/check_balance'
      : 'https://gift-card-service.wndsr.dev/check_balance';

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        givex_number: card_number,
        security_code: card_pin,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText);
    }

    const data = await response.json();
    return {
      ...data,
      status: 'success',
    };
  } catch (error) {
    const message = await getErrorMessageFromError(error.message);
    return {
      message,
      status: 'error',
    };
  }
};

export default () => {
  document.addEventListener('submit', async (e) => {
    if (e.target.matches('[data-gift-card-balance-form]')) {
      e.preventDefault();

      const form = e.target;
      const container = form.closest('[data-gift-card-balance-container]');
      const loading = form.parentNode.querySelector('[data-gift-card-loading]');
      const result = form.parentNode.querySelector('[data-gift-card-result]');
      const amount = form.parentNode.querySelector('[data-gift-card-balance]');
      const errorMessageElement = form.querySelector('.error-message');

      if (grecaptcha.getResponse() === '') {
        form.classList.add('GiftCardPage__balance-form--error');
        errorMessageElement.textContent = 'Please verify that you are not a robot.';
        form.style.display = 'block';
      } else {
        container.style.minHeight = `${container.offsetHeight}px`;
        form.style.display = 'none';
        loading.style.display = 'block';

        const card_number = form.querySelector('[name="card_number"]').value;
        const card_pin = form.querySelector('[name="card_pin"]').value;

        const res = await fetchGiftCardBalance(card_number, card_pin);
        const balance = res.status === 'success' ? res.certificate_balance : null;
        const errorMessage = res.status === 'error' ? res.message : '';

        if (balance) {
          form.style.display = 'none';
          form.classList.remove('GiftCardPage__balance-form--error');
          amount.textContent = balance;
          result.style.display = 'block';
        } else {
          form.classList.add('GiftCardPage__balance-form--error');
          errorMessageElement.textContent = errorMessage;
          form.style.display = 'block';
        }

        loading.style.display = 'none';
      }
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-check-another-card]')) {
      const container = e.target.closest('[data-gift-card-balance-container]');
      const form = container.querySelector('[data-gift-card-balance-form]');
      const result = container.querySelector('[data-gift-card-result]');
      const errorMessageElement = form.querySelector('.error-message');

      if (grecaptcha.getResponse() === '') {
        form.classList.add('GiftCardPage__balance-form--error');
        errorMessageElement.textContent = 'Please verify that you are not a robot.';
        form.style.display = 'block';
      } else {
        grecaptcha.reset();
      }

      form.querySelector('input[name="card_number"]').value = '';
      form.querySelector('input[name="card_pin"]').value = '';

      form.style.display = 'block';
      result.style.display = 'none';
    }
  });
};
